var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout"}},[_c('Header',{staticClass:"header"}),_c('router-view'),(_vm.showNav)?_c('SideNav',{staticClass:"sideNav"}):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }